import { Context, createContext } from 'react';

export type ContextProps = {
  controlId?: string;
  isCompleted?: boolean;
  isInvalid?: boolean;
  isDisabled?: boolean;
  isVerified?: boolean;
};

export const FormControlContext: Context<ContextProps> =
  createContext<ContextProps>({
    controlId: undefined,
  });
